// @core/api/endpoints/userprofile/get_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUISettingsResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get UI settings for profile
 * Retrieves the user's UI preferences including theme, layout options, and display settings. These settings persist across sessions and devices.
 */
export async function GetUISettings(
  profile_id: string,
  options?: RequestOptions
): Promise<GetUISettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/settings/ui`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<GetUISettingsResponse>(requestPath, { ...requestOptions });
}
